import React from 'react'
import FooterLogo from '../components/FooterLogo'

const Terms = () => {
  return (
    <>
      <div className="page-container col-sm-9 clearfix">
        <div id="rules-header">
          <div id="header-rules-text">
            <span className="count-down">Terms Of Use</span>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="shadow-sm feedback-grey-box p-5">
              <p>By registering for Open Play Tennis you agree to abide by the rules and regulations of Open Play Tennis, LLC. Players should familiarize themselves with the RULES section of Open Play Tennis.</p>
              <p>In the event of a match dispute, please contact the Open Play Tennis tournament chairman for resolution. The tournament chairman can be reached at: tchair@openplaytennis.com
                Please refrain from any inappropriate language on either the public or private message board system. Those that do not abide by standard decorum will be subjected to a warning and/or expulsion from Open Play Tenns at the sole discretion of the Open Play Tennis tournament chairman.
              </p>
              <p>Refunds will be granted for those that apply before the start of the season. Contact info@openplaytennis.com to request a refund. Once play has begun refunds will not be available.</p>
            </div>
          </div>
        </div>
      </div>
      <div className='footer_space'></div>
      <FooterLogo />
    </>
  )
}

export default Terms